import { User } from 'lucide-react';
import { useEffect, useRef } from 'react';
import { StepLayout } from '../StepLayout';
import type { OnboardingDraft } from '../types';

type Props = {
  draft: OnboardingDraft;
  setDraft: (patch: Partial<OnboardingDraft>) => void;
  onContinue: () => void;
  canContinue: boolean;
};

export function NameStep({ draft, setDraft, onContinue, canContinue }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);

  // Autofocus on mount so the keyboard slides up immediately.
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <StepLayout
      icon={<User size={28} strokeWidth={1.5} />}
      title="Welcome to Margin"
      description="What should we call you? Your name stays on this device. We don't sync or share it."
      onContinue={onContinue}
      canContinue={canContinue}
    >
      <input
        ref={inputRef}
        type="text"
        value={draft.name}
        onChange={(e) => setDraft({ name: e.target.value })}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && canContinue) onContinue();
        }}
        placeholder="First name"
        autoComplete="given-name"
        autoCapitalize="words"
        spellCheck={false}
        maxLength={40}
        className="w-full h-12 px-4 rounded-button bg-surface-secondary text-[18px] text-text-primary placeholder:text-text-tertiary focus:outline-none focus:ring-2 focus:ring-accent/40"
      />
    </StepLayout>
  );
}
